import { HttpClient } from '@angular/common/http';
import { Component, Inject, inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChecklistDialogComponent } from '../checklist-dialog/checklist-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AppStateService } from '../app-state.service';

@Component({
    selector: 'app-stupen-typ-studia',
    templateUrl: './stupen-typ-studia.component.html',
    styleUrl: './stupen-typ-studia.component.css',
    standalone: false
})

export class StupenTypStudiaComponent implements OnInit {

  dialog = inject(MatDialog);

  vybraneStupneStudiaKody: string[] = [];
  vybraneStupneStudiaString = '';
  vybraneTypyStudiaKody: string[] = [];
  vybraneTypyStudiaString = '';

  @Input() idTyp: number;
  @Input() poradieOpakovanejPolozky: number;
  @Input() idSkupina: number;
  @Input() castSkupiny: number;
  @Input() disabled: boolean = false;
  @Input() jazyk: string;

  constructor(private http: HttpClient,
    private translateService: TranslateService,
    private appStateService: AppStateService) {}

  ngOnInit(): void {

    // console.log('ngOnINIT');


    this.vybraneStupneStudiaString = this.translateService.instant('neurčený');
    this.vybraneTypyStudiaString = this.translateService.instant('neurčený');

    // prvykrat chceme naplnit stupne a typy hned po dotiahnuti dat
    this.appStateService.mapyPreVariant1Naplnene.subscribe(() => {
      this.naplnStupneATypyStudiaZaznamu();
    });

    // toto tu je kvoli tomu, ze pri prepinani jazykov vo formulari
    // sa uz stupne a typy nechceli dotiahnut
    this.naplnStupneATypyStudiaZaznamu();


    /*
      Ak je zvolena kombinacia jazykov formulara, pri zmene comboboxov pre stupen a typ studia
      v prvom jazyku nastavime na rovnaku hodnotu aj comboboxy pre stupen a typ v ostatnych jazykoch
    */
    if (this.appStateService.vybranyJazykFormulara.split(', ').length > 1) {

      const prvyJazyk = this.appStateService.vybranyJazykFormulara.split(', ')[0];
      // zmenu robime automaticky len pre ostatne jazyky (mimo prveho)
      if (this.jazyk !== prvyJazyk) {

        this.appStateService.zmenaVCombeStupnovStudia.subscribe((stupneStudiaCastiSkupiny) => {
          this.vybraneStupneStudiaString = stupneStudiaCastiSkupiny;
          this.vybraneStupneStudiaKody = stupneStudiaCastiSkupiny.split(', ');
        });

        this.appStateService.zmenaVCombeTypovStudia.subscribe((typyStudiaCastiSkupiny) => {
          this.vybraneTypyStudiaString = typyStudiaCastiSkupiny;
          this.vybraneTypyStudiaKody = typyStudiaCastiSkupiny.split(', ');
        });

      }

    }


  }

  openStupneStudiaDialog() {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/stupneStudia')
      .subscribe({
        next: (stupneStudiaINData: string[]) => {

          if (!stupneStudiaINData) {
            return;
          }

          const dialogRef = this.dialog.open(
            ChecklistDialogComponent, {
              data: {
                dataZoznam: stupneStudiaINData,
                title: this.translateService.instant('Stupne štúdia'),
                vybraneDataKodyList: this.vybraneStupneStudiaKody
              }
            }
          )

          dialogRef.afterClosed().subscribe((vybraneStupneKody:string[]) => {

            if (!vybraneStupneKody) {
              return;
            } else if (vybraneStupneKody.length === 0) {
              this.vybraneStupneStudiaString = this.translateService.instant('neurčený');
            }

            this.vybraneStupneStudiaKody = vybraneStupneKody;

            //naplnime globalne premenne z app-state.service ohladom vazby (SCSTTypZaznamuTextu.vazba)
            if (this.idSkupina) {
              // SKUPINOVE OPAKOVANIE
              const mapaHlavna = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliStupnovStudia;

              if (!mapaHlavna.get(this.idSkupina)) {

                const mapaCastiSkupinyAStupnov: Map<number, string[]> = new Map();
                mapaCastiSkupinyAStupnov.set(this.castSkupiny, vybraneStupneKody);
                mapaHlavna.set(this.idSkupina, mapaCastiSkupinyAStupnov);

              } else {

                const mapaCastiSkupinAStupnov = mapaHlavna.get(this.idSkupina);
                mapaCastiSkupinAStupnov.set(this.castSkupiny, vybraneStupneKody);

              }

              // pre skupinu treba v pripade zobrazenia formulara vo viacerych jazykoch
              // pri volbe stupna a typu naplnit rovnakymi hodnotami aj kombace v dalsich jazykoch
              if (this.appStateService.vybranyJazykFormulara.split(', ').length > 1) {
                const prvyJazyk = this.appStateService.vybranyJazykFormulara.split(', ')[0];
                // ak menim combo v 1. jazyku (vacsinou SK), vtedy o tom "informujem" kombace v inych jazykoch
                if (this.jazyk === prvyJazyk && vybraneStupneKody.length > 0) {
                  this.appStateService.zmenaVCombeStupnovStudia.next(vybraneStupneKody.join(', '));
                }
              }


            } else {
              // OPAKOVANA (NESKUPINOVA POLOZKA)

              if (!this.idTyp) {
                return;
              }

              if (this.poradieOpakovanejPolozky) {
                //AK IDE O OPAKOVANU (ale neskupinovu) POLOZKU

                //STUPNE STUDIA
                const mapaHlavnaStupne = this.appStateService.mapaIdTypovZaznamuAMapPoradiAStupnovStudia;

                if (!mapaHlavnaStupne.get(this.idTyp)) {
                  const mapaPoradiAStupnovStudia: Map<number, string[]> = new Map();
                  mapaPoradiAStupnovStudia.set(this.poradieOpakovanejPolozky, vybraneStupneKody);
                  mapaHlavnaStupne.set(this.idTyp, mapaPoradiAStupnovStudia);
                } else {
                  const mapaPoradiAStupnovStudia = mapaHlavnaStupne.get(this.idTyp);
                  mapaPoradiAStupnovStudia.set(this.poradieOpakovanejPolozky, vybraneStupneKody);
                }

              } else {

                // AK IDE O STANDARDNU, NIE OPAKOVANU POLOZKU
                const mapaHlavna = this.appStateService.mapaIdTypovZaznamuAStupnovStudia;
                mapaHlavna.set(this.idTyp, this.vybraneStupneStudiaKody);

              }

            }

            if (vybraneStupneKody.length > 0) {
              this.vybraneStupneStudiaString = vybraneStupneKody.join(', ');
            }

          });


        },
        error: (error) => {
          console.error(error);
        }
    });
  }

  openTypyStudiaDialog() {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/typyStudia')
      .subscribe({
        next: (typyStudiaINData: string[]) => {

          if (!typyStudiaINData) {
            return;
          }

          const dialogRef = this.dialog.open(
            ChecklistDialogComponent, {
              data: {
                dataZoznam: typyStudiaINData,
                title: this.translateService.instant('Typy štúdia'),
                vybraneDataKodyList: this.vybraneTypyStudiaKody
              }
            }
          )

          dialogRef.afterClosed().subscribe((vybraneTypyKody:string[]) => {

            if (!vybraneTypyKody) {
              return;
            } else if (vybraneTypyKody.length === 0) {
              this.vybraneTypyStudiaString = this.translateService.instant('neurčený');
            }

            this.vybraneTypyStudiaKody = vybraneTypyKody;

            //naplnime globalne premenne z app-state.service ohladom vazby (SCSTTypZaznamuTextu.vazba)
            if (this.idSkupina) {
              // SKUPINOVE OPAKOVANIE
              const mapaHlavna = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliTypovStudia;

              if (!mapaHlavna.get(this.idSkupina)) {

                const mapaCastiSkupinyATypov: Map<number, string[]> = new Map();
                mapaCastiSkupinyATypov.set(this.castSkupiny, vybraneTypyKody);
                mapaHlavna.set(this.idSkupina, mapaCastiSkupinyATypov);

              } else {

                const mapaCastiSkupinATypov = mapaHlavna.get(this.idSkupina);
                mapaCastiSkupinATypov.set(this.castSkupiny, vybraneTypyKody);

              }

              // TODO: pre skupinu treba v pripade zobrazenia formulara vo viacerych jazykoch
              // pri volbe stupna a typu naplnit rovnakymi hodnotami aj kombace v dalsich jazykoch
              if (this.appStateService.vybranyJazykFormulara.split(', ').length > 1) {

                const prvyJazyk = this.appStateService.vybranyJazykFormulara.split(', ')[0];
                // ak menim combo v 1. jazyku (vacsinou SK), vtedy o tom "informujem" kombace v inych jazykoch
                if (this.jazyk === prvyJazyk && vybraneTypyKody.length > 0) {
                  this.appStateService.zmenaVCombeTypovStudia.next(vybraneTypyKody.join(', '));
                }

              }

            } else {
              // OPAKOVANA (NESKUPINOVA POLOZKA)

              if (!this.idTyp) {
                return;
              }

              if (this.poradieOpakovanejPolozky) {
                // AK IDE O OPAKOVANU (ale NESKUPINOVU) POLOZKU

                // TYPY STUDIA
                const mapaHlavnaTypy = this.appStateService.mapaIdTypovZaznamuAMapPoradiATypovStudia;

                if (!mapaHlavnaTypy.get(this.idTyp)) {
                  const mapaPoradiATypovStudia: Map<number, string[]> = new Map();
                  mapaPoradiATypovStudia.set(this.poradieOpakovanejPolozky, vybraneTypyKody);
                  mapaHlavnaTypy.set(this.idTyp, mapaPoradiATypovStudia);
                } else {
                  const mapaPoradiATypovStudia = mapaHlavnaTypy.get(this.idTyp);
                  mapaPoradiATypovStudia.set(this.poradieOpakovanejPolozky, vybraneTypyKody);
                }

              } else {

                // AK IDE O STANDARDNU, NIE OPAKOVANU POLOZKU
                const mapaHlavna = this.appStateService.mapaIdTypovZaznamuATypovStudia;
                mapaHlavna.set(this.idTyp, this.vybraneTypyStudiaKody);

              }

            }

            if (vybraneTypyKody.length > 0) {
              this.vybraneTypyStudiaString = vybraneTypyKody.join(', ');
            }

          });

        },
        error: (error) => {
          console.error(error);
        }
    });
  }

  naplnStupneATypyStudiaZaznamu() {

    // console.log('naplnStupneATypyStudiaZaznamu()');

    if (this.idSkupina && this.idSkupina !== 0) {
      // SKUPINOVE OPAKOVANIE
      const mapaHlavna = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliStupnovStudia;
      const mapaCastiSkupinyAStupnov = mapaHlavna.get(this.idSkupina);
      if (mapaCastiSkupinyAStupnov && this.poradieOpakovanejPolozky) {
        this.vybraneStupneStudiaKody = mapaCastiSkupinyAStupnov.get(this.poradieOpakovanejPolozky);
        if (this.vybraneStupneStudiaKody && this.vybraneStupneStudiaKody.length > 0) {
          this.vybraneStupneStudiaString = this.vybraneStupneStudiaKody.join(', ');
        }
      }

      const mapaTypovHlavna = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliTypovStudia;
      const mapaCastiSkupinyATypov = mapaTypovHlavna.get(this.idSkupina);
      if (mapaCastiSkupinyATypov && this.poradieOpakovanejPolozky) {
        this.vybraneTypyStudiaKody = mapaCastiSkupinyATypov.get(this.poradieOpakovanejPolozky);
        if (this.vybraneTypyStudiaKody && this.vybraneTypyStudiaKody.length > 0) {
          this.vybraneTypyStudiaString = this.vybraneTypyStudiaKody.join(', ');
        }
      }

    } else  if (this.poradieOpakovanejPolozky) {

      // OPAKOVANE POLOZKY

      // STUPNE STUDIA
      const mapaStupnovHlavna = this.appStateService.mapaIdTypovZaznamuAMapPoradiAStupnovStudia;
      const mapaPoradiAStupnovStudia = mapaStupnovHlavna.get(this.idTyp);
      if (mapaPoradiAStupnovStudia) {
        const stupneStudiaPole = mapaPoradiAStupnovStudia.get(this.poradieOpakovanejPolozky);

        if (stupneStudiaPole && stupneStudiaPole.length > 0) {
          this.vybraneStupneStudiaKody = stupneStudiaPole;
          this.vybraneStupneStudiaString = stupneStudiaPole.join(', ');;
        }
      }


      // TYPY STUDIA
      const mapaTypovHlavna = this.appStateService.mapaIdTypovZaznamuAMapPoradiATypovStudia;
      const mapaPoradiATypovStudia = mapaTypovHlavna.get(this.idTyp);
      if (mapaPoradiATypovStudia) {
        const typyStudiaPole = mapaPoradiATypovStudia.get(this.poradieOpakovanejPolozky);

        if (typyStudiaPole && typyStudiaPole.length > 0) {
          this.vybraneTypyStudiaKody = typyStudiaPole;
          this.vybraneTypyStudiaString = typyStudiaPole.join(', ');;
        }

      }

    } else {

      // NEOPAKOVANE POLOZKY

      const stupneStudiaPole = this.appStateService.mapaIdTypovZaznamuAStupnovStudia.get(this.idTyp)
      if (stupneStudiaPole && stupneStudiaPole.length > 0) {
        this.vybraneStupneStudiaKody = stupneStudiaPole;
        this.vybraneStupneStudiaString = stupneStudiaPole.join(', ');
      }


      const typyStudiaPole = this.appStateService.mapaIdTypovZaznamuATypovStudia.get(this.idTyp);
      if (typyStudiaPole && typyStudiaPole.length > 0) {
        this.vybraneTypyStudiaKody = typyStudiaPole;
        this.vybraneTypyStudiaString = typyStudiaPole.join(', ');
      }


    }

  }

}
